import { deletePackage } from '@lib/axios/package'
import { useMutation, useQueryClient } from 'react-query'

const useDelete = () => {
  const queryClient = useQueryClient()
  return useMutation(
    (id) => deletePackage(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('saas-package')
      },
    }
  )
}

export default useDelete
